import mixins from 'vue-typed-mixins'
import Section from '@/calendesk/sections/section/mixins/Section'
import { mapActions } from 'vuex'
import Employee from '@/calendesk/models/DTO/Response/Employee'
import SectionConfigurationEmployee from '@/calendesk/models/SectionConfigurationEmployee'

export default mixins(Section).extend({
  data () {
    return {
      loading: false
    }
  },
  computed: {
    list (): Employee[] {
      if (this.employees) {
        const selectedEmployeeIds = this.data.configuration.wb_employee_list__employees__.map((item: SectionConfigurationEmployee) => item.id)
        return this.employees.filter((employee: Employee) => selectedEmployeeIds.includes(employee.id))
      }

      return []
    }
  },
  mounted () {
    this.loading = true
    this.fetchEmployees().finally(() => { this.loading = false })
  },
  methods: {
    ...mapActions({
      fetchEmployees: 'employee/fetch'
    }),
    generateSocialMediaList (employee: Record<string, any>): Array<Record<string, any>> {
      const result = []
      if (employee.youtube) result.push({ href: employee.youtube, icon: '$youtube' })
      if (employee.tiktok) result.push({ href: employee.tiktok, icon: '$tiktok' })
      if (employee.linkedin) result.push({ href: employee.linkedin, icon: '$linkedin' })
      if (employee.facebook) result.push({ href: employee.facebook, icon: '$facebook' })
      if (employee.instagram) result.push({ href: employee.instagram, icon: '$instagram' })
      if (employee.twitter) result.push({ href: employee.twitter, icon: '$x' })
      return result
    }
  }
})
